import { render, staticRenderFns } from "./AddInstitution.vue?vue&type=template&id=5c2bea00&scoped=true"
import script from "./AddInstitution.vue?vue&type=script&lang=js"
export * from "./AddInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bea00",
  null
  
)

export default component.exports